// extracted by mini-css-extract-plugin
module.exports = {"button":"Comments_button__1-5Ri","parent":"Comments_parent__uwVJW","index":"Comments_index__2ebUB","textfield":"Comments_textfield__3gK93","emptyBody":"Comments_emptyBody__2lm-Z"};